
import { combineReducers } from 'redux'
import { loginReducer } from '../Login/reducers/loginReducer'

import { organizationReducer } from '../Organization/reducers/organizationReducer'
import { superAdminLoginReducer } from '../SuperAdminLogin/reducer/superAdminLoginReducer'
import { superAdminLayoutReducer } from '../SuperAdminLayout/reducers/superAdminLayoutReducer'
import { forgotPasswordReducer } from '../ForgotPassword/reducers/forgotPasswordReducer'
import { resetPasswordReducer } from '../ForgotPassword/reducers/resetPasswordReducer'
import {heartRunnerRegistrationReducer} from '../HeartRunnerRegistration/reducers/registrationReducer';
import {heartRunnerReducer} from '../SuperAdminManagement/HeartRunner/reducers/heartRunnerReducer';
import {heartRunnerLoginReducer} from '../HeartRunnerLogin/reducer/heartRunnerLoginReducer';
import {heartRunnerprofileSettingsReducer} from '../HeartRunner/HeartRunnerManagement/reducers/heartRunnerprofileSettingsReducer';
import {pendingHeartRunnerReducer} from '../SuperAdminManagement/HeartRunner/reducers/pendingHeartRunnerReducer';
import {settingsHeartRunnerReducer} from '../SuperAdminManagement/HeartRunner/reducers/settingsHeartRunnerReducer';
import {TermsOfUseReducer} from '../SuperAdminSetting/reducer/termsOfuseReducer';
import {CarouselSettingReducer} from '../SuperAdminSetting/reducer/carouselSettingReducer';
import {ContactSettingReducer} from '../SuperAdminSetting/reducer/contactSettingReducer'; 
import {notificationReducer} from '../SuperAdminSetting/reducer/notificationReducer';
import {EmailSettingReducer} from '../SuperAdminSetting/reducer/emailSettingReducer';
import {AlarmRulesReducer} from '../SuperAdminSetting/reducer/alarmRulesReducer';
import {AlarmSoundReducer} from '../SuperAdminSetting/reducer/alarmSoundReducer'; 
import {generalSettingReducer} from '../SuperAdminSetting/reducer/generalSettingReducer'; 
import {feedbackSettingReducer} from '../SuperAdminSetting/reducer/feedbackSettingReducer'; 
import {rejectedHeartRunnerReducer} from '../SuperAdminManagement/HeartRunner/reducers/rejectedHeartRunnerReducer';
import {NotificationReducer} from '../SuperAdminLayout/reducers/notificationReducer';
import {deletedHeartRunnerReducer} from '../SuperAdminManagement/HeartRunner/reducers/deletedHeartRunnerReducer';
import {pendingEditProfileReducer} from '../SuperAdminManagement/HeartRunner/reducers/pendingEditProfileReducer'
import {viewFeedbackAnswerReducer} from '../SuperAdminManagement/HeartRunner/reducers/viewFeedbackAnswerReducer';
import { incomingAlarmListReducer } from '../SuperAdminManagement/HeartRunner/reducers/incomingAlarmListReducer';
import {AlarmStatusColorReducer} from '../SuperAdminSetting/reducer/alarmStatusColorReducer';
import {AlarmFieldsReducer} from '../SuperAdminSetting/reducer/alarmFieldsReducer';
import {PredefinedTextReducer} from '../SuperAdminSetting/reducer/predefinedTextReducer';
import { FAQReducer } from '../SuperAdminSetting/reducer/faqReducer';
import { PrivacyPolicyReducer } from '../SuperAdminSetting/reducer/privacyPolicyReducer';
import {RegionReducer} from '../SuperAdminSetting/reducer/regionReducer';
import { MonthlyReportReducer } from '../SuperAdminSetting/reducer/monthlyReportReducer';
import { ReportSubscriberReducer } from '../SuperAdminSetting/reducer/reportSubscriberReducer';
import { PermissionsReducer } from '../SuperAdminSetting/reducer/permissionsReducer';
import { CompanyBrandingReducer } from '../SuperAdminSetting/reducer/companyBrandingReducer';
import { UserAuthListReducer } from '../SuperAdminSetting/reducer/userAuthListReducer';
import { TetraResourcesReducer } from '../SuperAdminSetting/reducer/tetraResourcesReducer';
export default combineReducers({
    loginReducer,
    organizationReducer,
    UserAuthListReducer,
    TetraResourcesReducer,
    superAdminLoginReducer,
    superAdminLayoutReducer,
    forgotPasswordReducer,
    resetPasswordReducer,
    heartRunnerRegistrationReducer,
    heartRunnerReducer,
    heartRunnerLoginReducer,
    heartRunnerprofileSettingsReducer,
    pendingHeartRunnerReducer,
    settingsHeartRunnerReducer,
    TermsOfUseReducer,
    CarouselSettingReducer,
    ContactSettingReducer,
    notificationReducer,
    EmailSettingReducer,
    AlarmRulesReducer,
    AlarmSoundReducer,
    generalSettingReducer,
    feedbackSettingReducer,
    rejectedHeartRunnerReducer,
    NotificationReducer,
    deletedHeartRunnerReducer,
    pendingEditProfileReducer,
    viewFeedbackAnswerReducer,
    incomingAlarmListReducer,
    AlarmStatusColorReducer,
    AlarmFieldsReducer,
    PredefinedTextReducer,
    FAQReducer,
    PrivacyPolicyReducer,
    RegionReducer,
    MonthlyReportReducer,
    ReportSubscriberReducer,
    PermissionsReducer,
    CompanyBrandingReducer
})



























